// src/pages/Home.js
import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Footer from '../components/Footer';
import ValueSection from '../components/ValueSection';
import FeatureSection from '../components/FeatureSection';
import GlobalImpactSection from '../components/GlobalImpactSection';
import TrustedBySection from '../components/TrustedBySection';
import ShapeSection from '../components/ShapeSection';

const Home = () => {
  return (
    <div>
      <Header />
      <Hero />
      <ValueSection />
      <FeatureSection />
      <GlobalImpactSection />
      <TrustedBySection />
      <ShapeSection />
      <Footer/>
    </div>
  );
};

export default Home;
